import { useSetAtom } from "jotai";
import { modalState } from "@stores/modal";

export default function useModal() {
  const setAlert = useSetAtom(modalState);

  const showAlert = (msg, type = "confrim") => {
    return new Promise((res) => {
      setAlert({
        show: true,
        type: type,
        msg: msg,
        closeCallback: async (isYes) => {
          await setAlert({
            show: false,
            type: type,
            msg: "",
            closeCallback: null,
          });
          res(isYes);
        },
      });
    });
  };

  return {
    showAlert,
  };
}
